import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAccountWebHookAsync, resetSelectedRecordObjectInState, getSystemWebHookEventTypesAsync, DeleteSelectedAccountWebHookSubscriptionAsync,
     setPageSize, setSearchValue, updatePagination, updateSearchPagination, updateSorting, getAccountWebHookByAccountWebHookSubscriptionIdAsync } from "./WebHookSlice";
import { WebHookItem } from "./WebHookItem";
import { WebHookForm } from "./WebHookForm";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../../common/Pagination";
import { useDebounce } from "../../../_metronic/helpers";
import { ShowToast } from "../../../common/Toastr";
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


export const WebHook = () => {

    //const modelRef = useRef<any>(null);
    const { WebHookList, isReload, selectedRecord, isLoading,currentPage, pageSize,startRec, 
        start,pageNo,sortOrder, sortColumn , totalItems, search, recordsFiltered, WebhookSubscriptionCheckedIds, 
        isSearch, isReloadForIsDisabled, } = useAppSelector((state) => state.webHook);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();
    // const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    // useEffect(() => {
    //     dispatch(getAccountWebHookAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    //     // startRec == 0 && dispatch(getAccountWebHookByAccountWebHookSubscriptionIdAsync(sessionAccountEmployeeId))
    //     // setTab('TimeOffList');
    // }, [pageNo, pageSize, isSearch, sortOrder, sortColumn]);

    

    // const [sortConfig, setSortConfig] = useState({
    //     columnIndex: 1,
    //     direction: 'asc'
    // });





    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    // const onHandleSorting = (orderDir: string, order: string) => {
    //     let objects = {
    //         "orderDir": orderDir,
    //         "order": order,
    //         "startRec": 0,
    //         "pageSize": pageSize,
    //         "pageNo": 1
    //     }
    //     dispatch(updateSorting(objects));
    // }
    // const onHandlePageChange = (pageNumber: any) => {
    //     let objects = {
    //         "startRec": (pageNumber - 1) * Number(pageSize),
    //         "pageSize": 10,
    //         "pageNo": pageNumber,
    //         "search": search
    //     }
    //     dispatch(updatePagination(objects));
    // }

    // const onHandlePageSizeChange = (selectedOption: any) => {
    //     let objects = {
    //         "startRec": 0,
    //         "pageSize": selectedOption.value,
    //         "pageNo": 1,
    //         "search": search
    //     }
    //     dispatch(updatePagination(objects));
    // };

    // const onHandleSearch = (event: any) => {
    //     dispatch(updateSearchPagination(event.target.value));
    // };
    // useEffect(() => {
    //     if (isReloadForIsDisabled) {
    //         dispatch(getAccountWebHookAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    //     }
    // }, [isReloadForIsDisabled])

    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(getAccountWebHookAsync({ currentPage: 1, pageSize: 10, start: 0, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    //     }
    // }, [isReload])

    // useEffect(() => {
    //     dispatch(getAccountWebHookAsync({ currentPage: currentPage, pageSize: pageSize, start: 0, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    // }, [dispatch])


    // const debouncedSearchTerm = useDebounce(search, 500);

    // useEffect(() => {
    //     if (isSearch && debouncedSearchTerm !== ' ') {
    //         dispatch(getAccountWebHookAsync({ currentPage: 1, pageSize: pageSize, start: 0, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: debouncedSearchTerm }));
    //     }

    // }, [debouncedSearchTerm]);


    const debouncedSearchTerm = useDebounce(search, 500);

    useEffect(() => {
        if (isSearch && debouncedSearchTerm !== ' ') {
            dispatch(getAccountWebHookAsync());
        }

    }, [debouncedSearchTerm]); 
    
    useEffect(() => {
     
        dispatch(getAccountWebHookAsync());
        // startRec == 0 && dispatch(getAccountWebHookAsync())
        // setTab('TimeOffList');
    }, [ pageNo, pageSize, sortOrder, sortColumn, isReload]);

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        dispatch(getSystemWebHookEventTypesAsync());
        openModal();
    }
    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    const commaSeparatedString = WebhookSubscriptionCheckedIds.join(', ');
                    dispatch(DeleteSelectedAccountWebHookSubscriptionAsync(commaSeparatedString))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            console.log('originalPromiseResult:',originalPromiseResult);
                            originalPromiseResult[0].id !== -1 ?
                                ShowToast("WebHook Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {                            
                        })
                }
            })
            .catch((error) => {

            });

    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    // const handlePageChange = (pageNumber: any) => {
    //     const start = (pageNumber - 1) * pageSize;
    //     dispatch(getAccountWebHookAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    // };

    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     if (value !== ' ') {
    //         dispatch(setSearchValue(value));
    //     }
    //     //dispatch(getAccountWebHookAsync({ currentPage: 1, pageSize: pageSize, start: 0, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: value }));
    // };

    // const handlePageSizeChange = (event: any) => {
    //     const { value } = event;
    //     dispatch(setPageSize(Number(value)));
    //     dispatch(getAccountWebHookAsync({ currentPage: 1, pageSize: value, start: 0, order: sortConfig.columnIndex, orderDir: sortConfig.direction, search: " " }));
    // };

    return (
        <>
                   {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('WebHooks')} */}
                        {getValueFromResource('WebHooks',dispatch, t)}

                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={onHandleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                          /> */}

                            <PageSizeSelect onChange={onHandlePageSizeChange} />

                        </div>

                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(WebHookList.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={onHandlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={startRec}
                                    t={t}
                                    // recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}

                        {(WebHookList.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={onHandlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={startRec}
                                        t={t}
                                    // recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}
                        {(IsAdd || (IsDelete && WebHookList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }

                        {IsAdd &&
                            <button
                                type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: WebHookList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add WebHook')} */}
                                {getValueFromResource('Add WebHook',dispatch, t)}

                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: WebHookList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{WebHookList.filter((item: any) => item.isSelected === 1).length}</span>
                                     {/* {t('Selected')} */}
                                     {getValueFromResource('Selected',dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: WebHookList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <WebHookItem WebHookList={WebHookList} t={t} onopenModal={openModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>
            {isModalOpen &&
                <WebHookForm t={t} oncloseModal={closeModal} />
            }
        </>
    )
}